// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"a1y_a1z"};